import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inner-footer',
  templateUrl: './inner-footer.component.html',
  styleUrls: ['./inner-footer.component.scss']
})
export class InnerFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
